// export const mockClientItems = (itemsNumber = 100) => {
//   const mockItems = [];

//   for (let i = 1; i < itemsNumber + 1; i += 1) {
//     mockItems.push({
//       key: `${i}`,
//       GatewayName: "PPJ-BROWAN-3",
//       GatewayType: "LoRa",
//       LastPing: "2024-09-17 18:47:00",
//       LastOnline: "2024-09-17 18:47:00",
//       Status: i === 4 ? "red" : "green",
//     });
//   }
//   return mockItems;
// };


export const mockServerItems = async (serverOptions, items) => {
  const { page, rowsPerPage, sortBy, sortType } = serverOptions;
  // const serverItemsLength = 99;
  const serverItemsLength = items.length;

  // const serverTotalItems = mockClientItems(serverItemsLength);
  const serverTotalItems = items
  if (sortBy && sortType) {
    serverTotalItems.sort((a, b) => {
      if (a[sortBy] < b[sortBy]) return sortType === "desc" ? 1 : -1;
      if (a[sortBy] > b[sortBy]) return sortType === "desc" ? -1 : 1;
      return 0;
    });
  }
  await new Promise((s) => setTimeout(s, 2000));
  return {
    serverCurrentPageItems: serverTotalItems.slice(
      (page - 1) * rowsPerPage,
      page * rowsPerPage
    ),
    serverTotalItemsLength: serverItemsLength,
  };
};
